import { getMomentTz } from "@dexteel/mesf-core";
import { Box, Skeleton, Typography } from "@mui/material";
import { OverviewHeader } from "../models/types";

const moment = getMomentTz();

const fmtShortRange = (
	start: Date | null | undefined,
	end: Date | null | undefined,
): string => {
	if (!start || !end) return "-";
	return `${moment(start).format("HH:mm")} → ${moment(end).format("HH:mm")}`;
};

type Props = {
	today: Date;
	header:
		| Pick<
				OverviewHeader,
				"CurrShiftLabel" | "CurrCrew" | "CurrShiftStart" | "CurrShiftEnd"
		  >
		| null
		| undefined;
	loading?: boolean;
};

export const ShiftHeaderPill = ({ today, header, loading }: Props) => {
	if (loading) {
		return <Skeleton variant="rounded" width={360} height={32} />;
	}
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1.25,
				px: 1.25,
				py: 0.5,
				borderRadius: 1,
				backgroundColor: (theme) => theme.palette.success.light + "33",
				border: (theme) => `1px solid ${theme.palette.success.main}`,
			}}
		>
			<Typography
				sx={{
					fontSize: "0.8rem",
					fontWeight: 600,
					color: (theme) => theme.palette.success.dark,
					lineHeight: 1,
					fontVariantNumeric: "tabular-nums",
				}}
			>
				{moment(today).format("ddd, MMM D YYYY")}
			</Typography>
			{header && (
				<>
					<Box
						sx={{
							width: "1px",
							alignSelf: "stretch",
							backgroundColor: (theme) => theme.palette.success.main,
							opacity: 0.5,
						}}
					/>
					<Box sx={{ display: "flex", alignItems: "baseline", gap: 0.6 }}>
						<Typography
							sx={{
								fontSize: "0.65rem",
								color: (theme) => theme.palette.success.main,
								fontWeight: 600,
								textTransform: "uppercase",
								letterSpacing: 0.4,
							}}
						>
							Shift
						</Typography>
						<Typography
							sx={{
								fontSize: "0.95rem",
								fontWeight: 700,
								color: (theme) => theme.palette.success.dark,
								lineHeight: 1,
							}}
						>
							{header.CurrShiftLabel ?? "-"}
						</Typography>
						<Typography
							sx={{
								fontSize: "0.65rem",
								color: (theme) => theme.palette.success.main,
								fontWeight: 600,
								textTransform: "uppercase",
								letterSpacing: 0.4,
								ml: 0.5,
							}}
						>
							Crew
						</Typography>
						<Typography
							sx={{
								fontSize: "0.95rem",
								fontWeight: 700,
								color: (theme) => theme.palette.success.dark,
								lineHeight: 1,
							}}
						>
							{header.CurrCrew ?? "-"}
						</Typography>
						<Typography
							sx={{
								fontSize: "0.7rem",
								color: "#558b2f",
								fontWeight: 500,
								ml: 0.5,
								fontVariantNumeric: "tabular-nums",
							}}
						>
							{fmtShortRange(header.CurrShiftStart, header.CurrShiftEnd)}
						</Typography>
					</Box>
				</>
			)}
		</Box>
	);
};
